/**
 * This only use in useInfiniteQuery
 * @param arr any[]
 */
export const convertArrayOfObject = (arr: any[]) => {
  const result =
    arr?.reduce((previos: any[], current: any) => {
      return previos?.concat(current.data) || [];
    }, []) || [];
  return result;
};
